import styled, { css } from 'styled-components';

import { breakpoint } from 'styles/mixins';

export const FeedbackList = styled.ul`
	padding: 0;
	list-style-type: none;
`;

export const Item = styled.li`
	a {
		cursor: pointer;
		direction: rtl;
		text-align: right;
		display: flex;
		align-items: center;
		margin-bottom: 1.5rem;
	}
`;

export const DateHolder = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 60px;
	height: 60px;
	text-align: center;
	border-radius: 100%;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
	margin-left: 15px;

	${(p) =>
		p.$isToday
			? css`
					background-color: ${p.theme.color.primary};
					color: #fff;

					span {
						font-size: 16px;
					}
			  `
			: css`
					background-color: #fff;
					color: #000;

					span {
						font-size: 18px;
					}
			  `}

	${breakpoint.greaterThan('desktop')`
    margin-left: 30px;
  `}
`;

export const Date = styled.div`
	line-height: 1;

	span {
		display: block;
		line-height: 1;
		font-weight: 500;
	}

	small {
		display: block;
		line-height: 1;
		margin-top: 2px;
	}
`;

export const Body = styled.div`
	flex: 1 1;
	display: flex;
	position: relative;
	z-index: 1;

	${(p) =>
		p.$multiple &&
		css`
			&:after {
				content: '';
				position: absolute;
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
				background-color: #fff;
				border-radius: 10px;
				width: 100%;
				height: 100%;
				bottom: -6px;
				right: -6px;
				z-index: -9;
			}
		`}
`;

export const Inner = styled.div`
	display: flex;
	flex: 1 1;
	justify-content: space-between;
	align-items: center;
	color: #000;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
	background-color: #fff;
	border-radius: 10px;
	padding: 12px 16px;
	z-index: 1;
`;

export const Content = styled.div`
	flex: 1 1;

	h4 {
		font-weight: 500;
		font-size: 16px;
		margin-bottom: 0.25em;
	}

	h5 {
		font-weight: 300;
		font-size: 13px;
		margin-bottom: 0;
		color: #868f94;
	}
`;

export const IconHolder = styled.div`
	font-size: 1.5em;
	color: #737d83;
`;

export const Emoji = styled.img`
	display: inline-block;
	vertical-align: middle;
	width: 26px;
	height: 26px;
	margin: 0 0.35em;
`;

export const CircleIcon = styled.span`
	display: block;
	width: 26px;
	height: 26px;
	border: 1px solid #8e969b;
	border-radius: 100%;
	margin: 0 0.35em;
`;
